const dropslideItem = {
  create(props) {
    let markup = `
      <li class="mobileNav__item -dropslide" data-slug="${props.slug}">
        <a href="${props.link}" class="mobileNav__link -has-children -dropslide">${props.title}</a>
    `;

    if (props.children) {
      markup += `
        <a href="#" class="mobileNav__dropslideInvoker -dropslide js-dropslide-invoker" data-slug="${props.slug}">
          <svg class="icon -arrow-custom-right">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-custom-right"></use>
          </svg>
        </a>
      `;
    }

    markup += '</li>';

    return markup;
  },
};

export default dropslideItem;



// WEBPACK FOOTER //
// ./components/markup/dropslideItem.js